angular.module('tf.services')

    .factory('NavigationService', ['HttpService','$q','UrlEncodingService','$location','$rootScope','$window', 'BreadCrumbsService','NotificationService', '$state',
        function (HttpService,$q,UrlEncodingService, $location, $rootScope, $window, BreadCrumbsService, NotificationService, $state) {
            var service = {};

            service.getContent = function(path){
                var defer = $q.defer();
                $rootScope.$broadcast('working', true);
                UrlEncodingService.decrypt(path).then(function(decoded){
                    if(decoded.fid && decoded.path){

                        HttpService.get("farmer/" + decoded.fid + "/folders", { path: decoded.path }).then(function (res) {
                            $rootScope.$broadcast('working',false);
                            var data = res.data;
                            angular.forEach(data.content, function(folder){
                                folder.fid = decoded.fid;

                            });
                            BreadCrumbsService.set(data.breadcrumbs);
                            setCurrentLocation(data);
                            defer.resolve(data);
                        }, function(res){
                            $rootScope.$broadcast('working',false);
                            if(res.status === 403 || res.status === 503){
                                $window.location.href = '/';
                            }
                            if(res.status === 504){
                                var onConfirm = function () {
                                    $state.go('app.farmers', {}, {reload: true});
                                };
                                NotificationService.popup('confirm-general', {
                                    noCancel : true,
                                    title: 'Farmer is offline',
                                    content: 'Please check if the farmer is connected',
                                    onConfirm : onConfirm
                                });
                            }
                            defer.reject();

                        });


                    }
                    else{
                        $rootScope.$broadcast('working',false);
                        $window.location.href = '/';
                        defer.reject();
                    }
                }, function(){
                    $window.location.href = '/';
                    defer.reject();
                });

                return defer.promise;
            };


            function setCurrentLocation(data){
                var item = _.last(data.breadcrumbs);
                item.breadcrumbs = data.breadcrumbs.slice(0, -1);
                item.thumbnail = data.thumbnail;
                item.type = 0;
                $rootScope.currentLocation = item;
            }

            return service;
        }])
;
